import { sms } from '@axo/shared/data-access/types';
import { send } from '../../lib/send';
import { IAPI } from '../../lib/models/api';

export interface SMSTemplates {
  Items: sms.SMSTemplate[];
}

export function getSMSTemplates({ url: { service: baseURL }, token }: IAPI) {
  return (params: {
    marketCountry: string;
    broker: number;
  }): Promise<SMSTemplates> =>
    send({
      baseURL,
      token,
      path: `/sms-communication-template/template?active=true&marketCountry=${params.marketCountry}&broker=${params.broker}`,
      method: 'GET',
    });
}
